export const locales = {
  en: { name: 'English' },
  ru: { name: 'Русский' },
  de: { name: 'Deutch' },
}

export const defaultLocale = 'en'
